import {ModuleConfiguration} from "../router/model/UserPermission";
import {EMPLOYEE_PROFILE_SERVICE_MODULE_NAME} from "../utils/names/optionalModuleNames";
import {AngularJsMaterialModuleName} from "../utils/names/requiredModulesNames";

export const EmployeeProfileServiceModule =
    new ModuleConfiguration(
        EMPLOYEE_PROFILE_SERVICE_MODULE_NAME,
        [AngularJsMaterialModuleName]
    );